// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"registrationPage__wrapper__xlP5b","form":"registrationPage__form__3Watv","fieldWrapper":"registrationPage__fieldWrapper__2M-1_"};